import { Input, InputProps } from '@components/ui/form/input';
import { Textarea } from '@components/ui/form/textarea';
import { forwardRef } from 'react';
import { cn } from '@utils/cn';

interface JobSubTaskInputProps extends InputProps {
  valueType?: 'number' | 'text';
  label: string;
  suffix?: string;
  labelClassName?: string;
  inputClassName?: string;
  rightAlignValue?: boolean;
}

const TEXTAREA_CLASS_NAME =
  'h-8 min-h-[2rem] w-18 resize-y [scrollbar-width:none] [&::-webkit-scrollbar]:hidden';

export const JobSubTaskInput = forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  JobSubTaskInputProps
>(
  (
    { label, suffix, labelClassName, inputClassName, valueType, rightAlignValue, ...props },
    ref,
  ) => {
    const useTextarea = valueType === 'text' && !suffix;
    const title = props.value != null && props.value !== '' ? String(props.value) : undefined;

    return (
      <>
        <span
          className={cn(
            'flex h-fit items-center whitespace-normal break-words max-w-[20ch] text-sm font-medium text-neutral-800 max-[899px]:col-[1/-1] max-[899px]:max-w-none max-[899px]:pt-1.5',
            labelClassName,
          )}>
          {label}:
        </span>
        {useTextarea ? (
          <Textarea
            title={title}
            {...(props as unknown as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
            ref={ref as React.Ref<HTMLTextAreaElement>}
            autoComplete="off"
            className={cn(
              TEXTAREA_CLASS_NAME,
              inputClassName,
              'max-[899px]:col-[1/-1] max-[899px]:h-11 max-[899px]:w-full',
            )}
          />
        ) : (
          <Input
            title={title}
            {...props}
            ref={ref as React.Ref<HTMLInputElement>}
            type={valueType || 'text'}
            autoComplete="off"
            step="any"
            className={cn('[&>input]:min-w-0', inputClassName, 'max-[899px]:col-[1/-1]')}
            wrapperClassName="max-[899px]:h-11"
            rightAlignValue={rightAlignValue}
            suffixElement={<span className="font-semibold">{suffix}</span>}
          />
        )}
      </>
    );
  },
);
